export const EPOCH_INTERVAL = 9600;

// NOTE could get this from an outside source since it changes slightly over time
export const BLOCK_RATE_SECONDS = 3;

interface IAddresses {
  [key: number]: { [key: string]: string };
}
export const addresses: IAddresses = {
  43114: {
    USDT_ADDRESS: "0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664",
    TOKEN_ADDRESS: "0xb8E77650A0cCF5F680D795b326Ab18b6B58e5F19",
    PRESALE_ADDRESS: "0xaF48c734F431dbD71b7bc44D8186838fb45eEa55"
  },
};
